import https from "../utils/api";
// 获取项目效果图
export const getProjectImg = (sectionId) => {
  
  return https.get('/screen/project/image?sectionId='+sectionId).then(res=>{
    return res
  })
}
//判断加载模式
export const getShowType = () => {
  
  return https.get('/screen/project/show/type').then(res=>{
    return res
  })
}

// 获取管理人员
export const getProjectManager = () => {
  
  return https.get('/screen/project/manager').then(res=>{
    return res
  })
}
//获取工程概况参建单位
export const getProject = () => {
  
  return https.get('/screen/project').then(res=>{
    return res
  })
}

export const getDustData= (id) => {
  
  return https.get('/screen/roam/environment/'+id).then(res=>{
    return res
  })
}
export const getLine= (params) => {
  return https.post('/meteorological/average',params).then(res=>{
    return res
  })
}
export const getEquipmentList= (sectionId) => {
  return  https.get('/screen/roam?sectionId='+sectionId ,).then(res=>{
    return res
  })
}
//实名制通道
export const getRealNameData= (id) => {
  
  return https.get('/screen/roam/real_name/'+id).then(res=>{
    return res
  })
}
//视频通道
export const getVideoData= (id) => {
  
  return https.get('/screen/roam/video/'+id).then(res=>{
    return res
  })
}
export const getSectionList= () => {
  
  return https.get('/screen/project/section/list').then(res=>{
    return res
  })
}


